import { render, staticRenderFns } from "./SurveyHeader.vue?vue&type=template&id=9bb3ee68&lang=pug"
import script from "./SurveyHeader.vue?vue&type=script&lang=js"
export * from "./SurveyHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports